export const SERVER_URL = "https://www.cip-lucrative.com/api";
export const D2D_API_URL = "https://doc2data.in/api";


// export const SERVER_URL = "http://localhost:8000/api";
// export const D2D_API_URL = "http://localhost:8001/api";

export const D2D_API_KEY = 'fscwe5e543%$gvG&xdf!@cvg?>:vdscghdvgch^%^vgchvd'


